import { Box } from "@rebass/grid";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { useBrokerFeature } from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Banner,
  ESpacings,
  MultiStepForm,
} from "@rentiohq/web-shared/dist/components";
import createSchema from "../../../forms/tenantProfileBroker";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  performingSubmitActionResultSelector,
  submitActionCreator,
} from "../../../forms/tenantProfileBroker/schema.tenantProfileBroker.actions";

const formId = generateFormId();

const TenantProfilePreferences = () => {
  const { broker } = authHooks.useSelf();
  const hasRentMatch = useBrokerFeature(EBrokerFeature.RentMatch);

  const renderContent = () => {
    if (!broker) {
      return null;
    }

    return (
      <>
        <Box mb={ESpacings.loose}>
          <Banner
            hasDismiss={false}
            icon="contentPenWrite"
            // The sentence names the site the candidate is sent to, so it
            // has to name the right one. Brokers without the feature keep the
            // original wording, which is why this is a second key rather than
            // an edit of the first (DEV-3065).
            title={getLocalizedText(
              hasRentMatch
                ? "broker.rentmatch.tenant_profile.info.heading"
                : "broker.tenant_profile.info.heading",
            )}
          />
        </Box>
        <MultiStepForm
          formId={`update-broker-${formId}`}
          schemas={createSchema({ broker })}
          withAside={false}
          isPerformingSubmitActionSelector={isPerformingSubmitActionSelector(
            broker.id,
          )}
          performingSubmitActionResultSelector={performingSubmitActionResultSelector(
            broker.id,
          )}
          performingSubmitActionErrorSelector={performingSubmitActionErrorSelector(
            broker.id,
          )}
          submitActionCreator={submitActionCreator(broker.id)}
          submitLabel={getLocalizedText("system.save")}
        />
      </>
    );
  };

  return renderContent();
};

// eslint-disable-next-line import/no-default-export
export default TenantProfilePreferences;
